// extracted by mini-css-extract-plugin
export default {"formField":"selectIngka_formField__slbgo","select":"selectIngka_select__3fMhd"};